
<template>
  <div>
    <avatar-cropper
      :trigger="triggerId"
      :labels="cropperLabels"
      :upload-handler="onImageSelected"
      :cropper-options="{aspectRatio: 1.6}"
    />
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>Qualitäts-Prüfung</v-card-title>
        <v-card-text class="pa-0">
          <v-img v-if="imageDataUrl" :src="imageDataUrl" />
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn :disabled="loading" class="error" text @click="close()">
            <v-icon left>mdi-close</v-icon>{{$t('common.cancel')}}
          </v-btn>
          <v-spacer/>
          <v-btn :loading="loading" class="primary" text @click="imageConfirmed()">
            <v-icon left>mdi-check</v-icon>{{$t('common.ok')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";

export default {
  name: "ImageUploadWithPreview",
  components: {AvatarCropper},
  props: {
    triggerId: {
      type: String,
      required: true,
    },
    uploadAction: {
      type: Function,
      required: true,
    },
  },
  data: function () {
    return {
      dialog: false,
      cropperLabels: { submit: this.$t('common.preview'), cancel: this.$t('common.cancel') },
      imageData: undefined,
      loading: false,
    };
  },
  computed: {
    imageDataUrl: function() {
      var data = this.imageData;
      if (data) {
        var urlCreator = window.URL || window.webkitURL;
        var imageUrl = urlCreator.createObjectURL(data);
        return imageUrl;
      } else {
        return null;
      }
    }
  },
  watch: {
    visible: function (val) {
      this.dialog = val;
    },
    dialog: function (val) {
      if (val === false) {
        this.dialog = false;
      }
    },
    value: function () {
      // console.log("value changed to", val);
    },
  },
  created() {},
  mounted() {
    this.dialog = this.visible;
  },
  methods: {
    close() {
      this.$emit("input", this.user);
      this.dialog = false;
    },
    onImageSelected(cropperJS) {
      let canvas = cropperJS.getCroppedCanvas({ width: 640, height: 400 });
      canvas.toBlob((blob) => {
        const formData = new FormData();
        formData.append("file", blob);
        this.imageData = blob;
        this.dialog = true;
      });
    },
    imageConfirmed() {
      const formData = new FormData();
      formData.append("file", this.imageData);
      this.loading = true;
      this.uploadAction(formData).then(() => {
        this.loading = false;
        this.dialog = false;
      })
      .catch(error => {
        this.loading = false;
        this.$common.onError(error)
      });
    }
  },
};
</script>

<style>
.avatar-cropper-footer {
  background-color: #272727;
}

.avatar-cropper-btn:nth-child(1) {
  background-color: var(--v-error-base) !important;
}

.avatar-cropper-btn:nth-child(2) {
  background-color: var(--v-primary-base) !important;
}

.cropper-line {
  background-color: var(--v-accent-base) !important;
}

.cropper-view-box {
  outline: 1px solid #39f;
  outline-color: var(--v-accent-base) !important;
}

.cropper-point {
  background-color: var(--v-accent-base) !important;
}

.avatar-cropper-mark {
  display: none;
}
</style>
